import { createContext } from 'react';

const EditableContext = createContext();

export default EditableContext;
